export default "__VITE_PUBLIC_ASSET__62da2278__"